import { render, staticRenderFns } from "./TheUserList.vue?vue&type=template&id=8c50a608&scoped=true"
import script from "./TheUserList.vue?vue&type=script&lang=ts"
export * from "./TheUserList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c50a608",
  null
  
)

export default component.exports